/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Jehangir Rauf",
  title: "Hi all, I'm Jehangir Rauf",
  subTitle: emoji(
    "An experienced Android Developer 🚀 passionate about creating user-friendly and high-quality apps. AI Enthusiast exploring Large Language Models."
  ),
  resumeLink: require("./assets/resume.pdf"),
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/jahangirjadi",
  linkedin: "https://www.linkedin.com/in/jahangirjadi/",
  gmail: "jahangir.jadi@gmail.com",
  // gitlab: "https://gitlab.com/jahangirjadi",
  // facebook: "https://www.facebook.com/saad.pasta7",
  medium: "https://medium.com/@jahangir.jadi",
  stackoverflow: "https://stackoverflow.com/users/9075811/jahangir-jadi",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "PASSIONATE MOBILE APPLICATION DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop and build high-quality Android apps using Kotlin and Jetpack Compose"
    ),
    emoji(
      "⚡ Integration of third party services such as Firebase/Google Maps/Payment Gateways"
    ),
    emoji(
      "⚡ Exploring AI and Large Language Models"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "kotlin",
      fontAwesomeClassname: "fas fa-code" // generic code icon or custom
    },
    {
      skillName: "java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "android",
      fontAwesomeClassname: "fab fa-android"
    },
    {
      skillName: "dart",
      fontAwesomeClassname: "fas fa-bullseye" // placeholder for dart
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "javascript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "typescript",
      fontAwesomeClassname: "fab fa-js-square" // close enough
    },
    {
      skillName: "angular",
      fontAwesomeClassname: "fab fa-angular"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "git",
      fontAwesomeClassname: "fab fa-git"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Iqra University",
      logo: require("./assets/images/iu_logo.jpg"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "2015 - 2019",
      desc: "Completed a rigorous four-year program, earning a Bachelor of Science degree in Computer Science",
    },
    {
      schoolName: "Sir Adamjee Institute",
      logo: require("./assets/images/sai_logo.png"),
      subHeader: "Intermediate In Pre-Engineering",
      duration: "2012 - 2014",
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Android (Kotlin/Java)", //Insert stack or technology you have experience in
      progressPercentage: "95%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Jetpack Compose",
      progressPercentage: "90%"
    },
    {
      Stack: "Web Development",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Senior Android Developer",
      company: "Supporting Hands Care Services Ltd",
      companylogo: require("./assets/images/black.jpg"), // Placeholder or existing
      date: "Dec 2023 – Present",
      desc: "Manchester, UK",
      descBullets: [
        "Developed full fledged apps using Modern App Development practices to create scalable and robust applications.",
        "Integrated AI in the app for document summarization which helps the users to summarize long documents faster and efficiently.",
        "Created an AI Chatbot which helps the users to get relevant information about the system.",
        "Created Dynamic Forms using Jetpack Compose which improved the form creation and submission by 3x.",
        "Established technical practices for testing the code which reduced the error rate by 10%.",
        "Implemented security measures such as ProGuard/R8 to safeguard business and customer data."
      ]
    },
    {
      role: "Android Developer",
      company: "Infox Technologies",
      companylogo: require("./assets/images/infoxx.png"),
      date: "Mar 2021 – Aug 2023",
      desc: "Karachi, Pakistan",
      descBullets: [
        "Mentored junior developers and fostered a culture of innovation and teamwork.",
        "Developed a production management app, streamlining operational workflows using MVVM architecture and Kotlin.",
        "Implemented Web3 module in an app for doing transactions of crypto coins.",
        "Implemented Trust Wallet SDK for managing digital wallet within the app.",
        "Optimized UI by transforming XML layouts to Jetpack Compose, reducing UI development time by 30%.",
        "Integrated WebRTC to enable seamless audio/video communication."
      ]
    },
    {
      role: "Junior Android Developer",
      company: "Right Solutions",
      companylogo: require("./assets/images/right_solution.png"),
      date: "Sep 2019 – Mar 2021",
      desc: "Karachi, Pakistan",
      descBullets: [
        "Developed a complete Food Ordering App using the MVC design pattern.",
        "Featured real-time order tracking and push notifications.",
        "Achieved 1,000+ user sign-ups within the first quarter."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "SOME STARTUPS AND PERSONAL PROJECTS",
  projects: [
    {
      image: require("./assets/images/bialah.webp"),
      projectName: "Bialah",
      projectDesc: "E-Commerce App. Bialah offers you several options from stores of roses, hospitality, gifts and other party products and services.",
      footerLink: [
        {
          name: "Visit App",
          url: "https://play.google.com/store/apps/details?id=com.bialah.client&hl=en_US&gl=US"
        }
      ]
    },
    {
      image: require("./assets/images/dale_logo.png"),
      projectName: "Dale3Jo3ak",
      projectDesc: "Food Ordering App. Dale3 Jo3ak is a platform that helps you find and order food from wherever you are.",
      footerLink: [
        {
          name: "Visit App",
          url: "https://play.google.com/store/apps/details?id=com.mobiwhiz.dale3jo3ak&hl=en_GB"
        }
      ]
    },
    {
      image: require("./assets/images/googleAssistantLogo.webp"), // Placeholder for Bookpedia
      projectName: "Bookpedia",
      projectDesc: "A book library app built with Compose Multi Platform utilizing modern Android technologies (MVI, Ktor, Room, Koin). Compatible with Android, iOS and Desktop.",
      footerLink: []
    },
    {
      image: require("./assets/images/pwa.webp"), // Placeholder for Notes
      projectName: "Notes App",
      projectDesc: "Built using Compose Multi Platform utilizing Modern Android Development practices to create and save notes locally.",
      footerLink: []
    },
    {
      image: require("./assets/images/developerActivity.svg"), // Placeholder for Crypto
      projectName: "Crypto Tracker",
      projectDesc: "Shows a list of crypto currencies and their market cap. Utilizes Jetpack Compose, MVI Architecture, and Koin.",
      footerLink: []
    },
    {
      image: require("./assets/images/skill.svg"), // Placeholder for Tic Tac Toe
      projectName: "Tic Tac Toe",
      projectDesc: "Online game built using Jetpack Compose and Kotlin. Play with friends in real-time.",
      footerLink: []
    }

  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle: "",
  achievementsCards: [
    {
      title: "PL-Coding Android Course",
      subtitle:
        "Completed (The Essentials of Industry-Level Android App Development) Course",
      image: require("./assets/images/pl_coding.webp"),
      imageAlt: "PL-Coding",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1Z_V-h9kFyERncAhgPoBcT8w2A7OOdPS9/view?usp=drive_link"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://drive.google.com/drive/folders/1_eku2-Tj7iEPvO850oXVyoFnxmOgh5F0"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",
  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-334-3295489",
  email_address: "jahangir.jadi@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};